var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header'),_c('div',{attrs:{"id":"page"}},[_c('page-main'),_c('page-info'),_c('page-footer')],1),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading",attrs:{"id":"loading"}},[_c('div',[_c('img',{attrs:{"src":require("@/assets/images/public/loading.gif"),"alt":""}})])])
}]

export { render, staticRenderFns }